import ReactDOM from 'react-dom';
import App from './pages/App';
import { BrowserRouter as Router } from 'react-router-dom';
//import ReactGA from 'react-ga';
import './styles/index.scss';
import {keycloak} from "./keycloak-config";
import api from '../src/api';
import Routes from './components/Routes';
import {showError} from "./elements/Toasts/toastActions";
import { setAuthDetails } from "./components/auth/redux/authActions";


// import * as CodeMirror from 'codemirror';

// window.CodeMirror = CodeMirror;

/*ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY);

history.listen(function (location) {
  ReactGA.pageview(location.pathname + location.search);
});*/

// https://developer.mozilla.org/en-US/docs/Web/API/History/scrollRestoration
if (window.history.scrollRestoration) {
  window.history.scrollRestoration = 'manual';
}

const initKeycloak = (onAuthenticatedCallback) => {
    keycloak.onAuthSuccess = async () => {
        const termAgreement = await api.portal.checkTermAgreement();
        try {
            const response = await termAgreement.json();
            if (200 === termAgreement.status) {
                const agreed = response.data;
                if (!agreed) {
                    if (window.location.pathname !== Routes.TERM_OF_USE.path) {
                        window.location.href = Routes.TERM_OF_USE.path;
                    }
                }
                setAuthDetails(response);
            } else {
                console.log(response.message);
                showError('Failed to check the terms of the agreement');
            }
        } catch (e) {
            console.log(e);
            showError('Failed to check the terms of the agreement');
        }
    };
    keycloak.onTokenExpired = () => {
        keycloak.updateToken(5).then(function(refreshed) {
            if (refreshed) {
                console.log('Token was successfully refreshed');
            } else {
                console.log('Token is still valid');
            }
        }).catch(function() {
            console.log('Failed to refresh the token, or the session has expired');
            keycloak.clearToken();
            window.location.href = keycloak.createLoginUrl();
        });
    };
    keycloak.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        pkceMethod: 'S256',
        promiseType: 'native',
        refreshToken: 5
    })
        .then((authenticated) => {
            if (!authenticated) {
                console.warn("not authenticated!");
            }
            onAuthenticatedCallback();
        })
        .catch(ignored => {
        })
};

const renderApp = () => ReactDOM.render(
    <Router>
        <App />
    </Router>,
    document.getElementById('root')
);

initKeycloak(renderApp);
